import { Box, Typography } from "@mui/material";
import {useTranslation} from "react-i18next";
import {PRODUCT_INFO} from "../../../locales/components/namespaces";

type CartHeaderProps = {
    totalItems: number;
};

export default function CartHeader({ totalItems }: CartHeaderProps) {
    const {t} = useTranslation(PRODUCT_INFO);
    return (
        <Box
            sx={{
                width: "100%",
                display: "flex",
                flexDirection: "row",
                alignItems: { xs: "flex-start", md: "flex-end" },
                justifyContent: "space-between",
                gap: { xs: 2, md: 6 },
            }}
        >
            <Typography
                component="h1"
                sx={{
                    fontFamily: '"Zen Maru Gothic", system-ui, sans-serif',
                    fontWeight: 800,
                    fontSize: { xs: 26, sm: 32, md: 40, lg: 40 },
                    lineHeight: 0.9,
                    textTransform: "uppercase",
                    color: "#111111",
                }}
            >
                {t("My cart")}
            </Typography>
            <Typography
                sx={{
                    fontFamily: '"Roboto Condensed", system-ui, sans-serif',
                    fontWeight: 700,
                    fontSize: { xs: 13, md: 16 },
                    lineHeight: 1.2,
                    textAlign: "right",
                    color: "#8D8D8D",
                    whiteSpace: "nowrap",
                }}
            >
                {totalItems} {totalItems === 1 ? t('Product') : t("Products")}
            </Typography>
        </Box>
    );
}
